export default "__VITE_ASSET__59292572__"